import { render, staticRenderFns } from "./SunMoon.vue?vue&type=template&id=99cc2190&scoped=true&"
import script from "./SunMoon.vue?vue&type=script&lang=js&"
export * from "./SunMoon.vue?vue&type=script&lang=js&"
import style0 from "./SunMoon.vue?vue&type=style&index=0&id=99cc2190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cc2190",
  null
  
)

export default component.exports